import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Divider, Tab } from '@mui/material';
import { WorkflowStepsProvider } from 'context/workflow-steps-context';
import Departments from './departments/departments';
import Machines from './machines/machines';
import PauseReasons from './pause-reasons/pause-reasons.component';
import ProductionPlanTemplates from './production-plan-templates/production-plan-templates';
import WorkflowSettings from './workflow-settings/workflow-settings.components';
import { DepartmentsProvider } from 'context/departments-context';

const ProductionWorkflowSettings: FC = () => {
    const { t: translate } = useTranslation(['lab-settings', 'orders', 'workflow']);
    const [tabState, setTabState] = React.useState('workflow-steps');

    const handleChange = (newValue: string) => {
        setTabState(newValue);
    };

    return (
        <TabContext value={tabState}>
            <Box mb={1} display="flex" justifyContent="space-between" alignItems="center">
                <TabList onChange={(_, value) => handleChange(value)}>
                    <Tab label={translate('lab-settings:WORKFLOW_STEPS')} value="workflow-steps" />
                    <Tab label={translate('lab-settings:DEPARTMENTS')} value="departments" />
                    <Tab label={translate('lab-settings:PRODUCTION_PLANS')} value="production-plans" />
                    <Tab label={translate('lab-settings:MACHINES')} value="machines" />
                    <Tab label={translate('lab-settings:PAUSE_REASONS_TAB')} value="pause" />
                </TabList>
            </Box>
            <Box mb={3}>
                <Divider />
            </Box>
            <WorkflowStepsProvider>
                <DepartmentsProvider>
                    <TabPanel sx={{ padding: 0 }} value="workflow-steps">
                        <WorkflowSettings />
                    </TabPanel>
                    <TabPanel sx={{ padding: 0 }} value="departments">
                        <Departments />
                    </TabPanel>
                    <TabPanel sx={{ padding: 0 }} value="production-plans">
                        <ProductionPlanTemplates />
                    </TabPanel>
                    <TabPanel sx={{ padding: 0 }} value="machines">
                        <Machines />
                    </TabPanel>
                    <TabPanel sx={{ padding: 0 }} value="pause">
                        <PauseReasons />
                    </TabPanel>
                </DepartmentsProvider>
            </WorkflowStepsProvider>
        </TabContext>
    );
};

export default ProductionWorkflowSettings;
